import React, { Component } from 'react';
import './DrugBoxDetailsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import models from '../../model/models';
import utils from '../../utils/utils';
import objUtils from '../../utils/objUtils';
import DrugCard from '../../cards/drugCard/DrugCard';
import Button from '../../components/button/Button';
import EditDrugBoxPopup from './editDrugBoxPopup/EditDrugBoxPopup';
import CardHeader from '../../components/cardHeader/CardHeader';
import mainAPI from '../../api/MainAPI';
import HeaderRow from '../../components/headerRow/HeaderRow';
import Row from '../../components/row/Row';
import ImagePopup from "../../popups/imagePopup/ImagePopup";
import DrugTypeSummary from "../../cards/drugTypeSummary/DrugTypeSummary";

export default class DrugBoxDetailsPage extends Component {
	constructor(props) {
		super(props);
		this.state = { drug_box: null };
	}

	componentDidMount = () => {
		this.typeSubscribeId = models.drug_type.onChange(this._getData);
		this.subscribeId = models.drug_box.onChange(this._getData);
		this.drugSubId = models.drug.onChange(this._getData);
		this.userGroupSubId = models.user_group.onChange(this._getData);
	};

	componentWillUnmount = () => {
		models.drug_box.unsubscribe(this.subscribeId);
		models.drug.unsubscribe(this.drugSubId);
		models.user_group.unsubscribe(this.userGroupSubId);
		models.drug_type.unsubscribe(this.typeSubscribeId);
	};

	_getData = () => {
		let drug_box = models.drug_box.obj(this.props.match.params.id);
		if (!drug_box) return;
		let user_group = models.user_group.obj();
		if (!user_group) return;
		let drugs = models.drug.objs();
		drugs = objUtils.filter(drugs, 'drug_box_id', drug_box.id);
		this.setState({ drug_box, drugs, user_group });
		this._getTransferData().catch(console.error);
		this._getBoxChecks().catch(console.error);
		this._updateDrugTypes()
	};

	_getTransferData = async () => {
		const id = this.props.match.params.id;
		let transfers = await mainAPI.box_transfer.for_box(id);
		this.setState({ transfers });
	};
	_getBoxChecks = async () => {
		let box_checks = await mainAPI.box_check.paginated({drug_box_id:this.props.match.params.id, limit: 10});
		this.setState({ box_checks });
	};

	_showEditModal = () => {
		this.setState({ edit: true });
	};

	_hideEditModal = () => {
		this.setState({ edit: false });
	};

	_updateDrugTypes = () => {
		let types = models.drug_type.allowed();
		this.setState({ types });
	};
	renderTransferList = () => {
		let transfers = this.state.transfers;
		if (!transfers) return null;
		let columns = [
			{ label: 'Transferred by' },
			{ label: 'Transferred on' },
			{ label: 'From unit' },
			{ label: 'To unit' }
		];
		let display = [<HeaderRow columns={columns} />];
		for (let i in transfers) {
			display.push(
				<Row key={i}>
					<Label> {transfers[i].user_name}</Label>
					<Label> {utils.display_actual_datetime(transfers[i].created_on)}</Label>
					<Label> {transfers[i].from_unit_name}</Label>
					<Label> {transfers[i].to_unit_name}</Label>
				</Row>
			);
		}
		return display;
	};

	showImagePopup = (src) => {
	  window.popupController.show(ImagePopup, {src});
	};
	renderBoxChecks = () => {
		let box_checks = this.state.box_checks;
		if (!box_checks) return null;

		let columns = [
			{ label: 'Checked by' },
			{ label: 'Checked on' },
			{ label: 'Resealed Code' },
		];
		// eslint-disable-next-line no-undef
		if(this.state?.user_group?.allow_image_upload){
			columns.push({ label: '' });
		}
		let display = [<HeaderRow columns={columns} />];
		for (let i in box_checks) {
			const fullUrl =  mainAPI.rootURL() + box_checks[i].image_url + "&token=" + localStorage.token + '&last_log_in=' + Date.now();
			const otherProps = {};

			let imageColumn = null;
			// eslint-disable-next-line no-undef
			if(this.state?.user_group?.allow_image_upload) {
				imageColumn = box_checks[i].image_url ? <img src={fullUrl}/> : <div></div>;
				if (box_checks[i].image_url) {
					otherProps.onClick = x=>this.showImagePopup(fullUrl);
				}
			}

				display.push(
				<Row key={i} className={'image-row'} {...otherProps}>
					<Label> {box_checks[i].user__first_name + ' ' + box_checks[i].user__last_name}</Label>
					<Label> {utils.display_actual_datetime(box_checks[i].created_on)}</Label>
					<Label> {box_checks[i].reseal_box_barcode_id}</Label>
					{imageColumn}
				</Row>
			);
		}
		return display;
	};

	render() {
		let drug_box = this.state.drug_box || {};
		let lastCheck = null;
		if (drug_box.last_checked_on) {
			lastCheck = utils.display_date(utils.server_to_client_datetime(drug_box.last_checked_on));
		}
		return (
			<Page className="g-drug-box-details-page">
				<EditDrugBoxPopup show={this.state.edit} drug_box={this.state.drug_box} onClose={this._hideEditModal} />
				<Card half>
					<CardHeader>Drug Box</CardHeader>
					<Button className="edit-box" color="white" bg="blue" onClick={this._showEditModal}>
						Edit
					</Button>
					<div className="groups">
						<div className="group">
							<Label black bold>Code</Label>
							<Label>{utils.upperCase(drug_box.barcode_id)}</Label>
						</div>
						<div className="group">
							<Label black bold>Name</Label>
							<Label>{drug_box.name}</Label>
						</div>
						<div className="group">
							<Label black bold>Unit</Label>
							<Label>{drug_box.unit__name}</Label>
						</div>

					</div>
				</Card>
				<Card half>
					<Label larger black>
						Recent Activity
					</Label>
					<div className="groups">
						<div className="group">
							<Label black bold>Last checked</Label>
							<Label>{lastCheck}</Label>
						</div>
						<div className="group">
							<Label black bold>Last check</Label>
							<Label>{drug_box.last_checked_by}</Label>
						</div>
					</div>
				</Card>
				<DrugTypeSummary types={this.state.types} drugs={this.state.drugs} hideEmpty/>
				<DrugCard drugs={this.state.drugs}>
					{/*<Button color='white' bg='blue' onClick={() => {*/}
					{/*history.navigate('/reports/drug_box/' + drug_box.id)*/}
					{/*}}>Run Report</Button>*/}
				</DrugCard>

				<Card className="transfers">
					<CardHeader>Unit Transfers</CardHeader>
					{this.renderTransferList()}
				</Card>

				<Card className="box-checks">
					<CardHeader>Recent Inventory checks</CardHeader>
					{this.renderBoxChecks()}
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/drugBoxDetailsPage/DrugBoxDetailsPage.jsx